export const auditSkill = (skill) => {
  // Layer 1: Required field validation
  if (!skill.name || !skill.description || !skill.category) {
    return { status: "rejected", feedback: "Missing required fields (name, description, or category).", layer: 1 };
  }

  const errors = [];
  if (!skill.name || skill.name.length < 3) errors.push ? errors.push("Name too short (min 3 characters)") : null;
  if (!skill.description || skill.description.length < 20) errors.push("Insufficient description (min 20 characters)");
  if (!skill.steps || skill.steps.length < 30) errors.push("Insufficient flow steps");
  if (!skill.category) errors.push("Category not provided");

  if (errors.filter(Boolean).length > 0 && (!skill.description || skill.description.length < 20)) {
    return { status: "rejected", feedback: "Missing or insufficient required fields.", layer: 1, errors: errors.filter(Boolean) };
  }

  // Layer 2: Quality heuristic
  let score = 0;
  score += skill.description.length > 20 ? 30 : 10;
  score += skill.description.length > 100 ? 20 : 0;
  score += skill.steps && skill.steps.length > 30 ? 25 : 10;
  score += skill.steps && skill.steps.length > 100 ? 15 : 0;
  score += skill.name && skill.name.length > 5 ? 10 : 5;
  if (skill.tags && skill.tags.length > 0) score += 10;
  if (skill.price && parseFloat(skill.price) >= 0) score += 5;

  if (score >= 70) return { status: "approved", score, layer: 2, feedback: "Skill automatically approved." };
  if (score >= 40) return { status: "review_queue", score, layer: 2, feedback: "Skill sent for manual review." };

  return { status: "rejected", score, layer: 2, feedback: "Quality too low. Please revise and resubmit.", errors: errors.filter(Boolean) };
};

export const autoAuditSkills = (skills) => {
  return skills.map((skill) => ({
    ...skill,
    auditResult: auditSkill(skill),
  }));
};

export const getAuditQueue = (skills) => {
  return autoAuditSkills(skills).filter((s) => s.auditResult.status === "review_queue");
};

export const getAuditStats = (skills) => {
  const results = autoAuditSkills(skills);
  return {
    total: results.length,
    approved: results.filter((s) => s.auditResult.status === "approved").length,
    rejected: results.filter((s) => s.auditResult.status === "rejected").length,
    review: results.filter((s) => s.auditResult.status === "review_queue").length,
  };
};
